const makeChoice = ({text = ''} = {}) => ({
  type: 'choice',
  children: [{
    text,
  }],
});

export default makeChoice;
